import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Upload, Icon, notification, Row, Col, Typography, InputNumber, Carousel, Switch, DatePicker, Tag } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import moment from 'moment';
import './ExperienceUpdate.css';

const { TextArea } = Input;
const { Text, Paragraph } = Typography;

@inject(
    'CmsLanguageStore',
    'CmsExperienceStore'
)
@observer
class ExperienceUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    create = () => {
        this.props.CmsExperienceStore.create().then(() => {
            this.props.CmsExperienceStore.setupdateLoading(false);
            this.props.CmsExperienceStore.setshowModal(false);
            this.props.CmsExperienceStore.getAll();
        });
    }

    update = () => {
        this.props.CmsExperienceStore.update().then(() => {
            this.props.CmsExperienceStore.setupdateLoading(false);
            this.props.CmsExperienceStore.setshowModal(false);
            this.props.CmsExperienceStore.getAll();
        });
    }

    cancel = () => {
        this.props.CmsExperienceStore.setshowModal(false);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsExperienceStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsExperienceStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'HotelEvent'
                const titleName = title || 'Default'

                return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsExperienceStore.setImageUrlById(id, response.imageUrl)
                    this.props.CmsExperienceStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            experience,
            updateLoading,
            images
        } = this.props.CmsExperienceStore;

        let hasError = true;

        const defaultLang = experience.experienceLanguages.find(fi => fi.languageId === 1);
        if (defaultLang) {
            hasError = images.length === 0 || defaultLang.title === '' || defaultLang.briefDescription === '' || defaultLang.description === '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                experience
                                    ?
                                    <>
                                        <Form layout='vertical'>

                                            {/* Title */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Title</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                experience.experienceLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={2}
                                                                                                        value={experience.experienceLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                        onChange={(e) => this.props.CmsExperienceStore.settitle(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Brief Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Brief Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                experience.experienceLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={3}
                                                                                                        value={experience.experienceLanguages.find(fi => fi.languageId === lang.id).briefDescription}
                                                                                                        onChange={(e) => this.props.CmsExperienceStore.setbriefDescription(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                experience.experienceLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <CKEditor
                                                                                                        editor={ClassicEditor}
                                                                                                        data={experience.experienceLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                        onChange={(event, editor) => {
                                                                                                            const data = editor.getData();
                                                                                                            this.props.CmsExperienceStore.setdescription(lang.id, data)
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Show Banner Only */}
                                            <>
                                                <Form.Item label='Show Banner Only'>
                                                    <Switch
                                                        checkedChildren='Yes'
                                                        unCheckedChildren='No'
                                                        checked={experience.showBannerOnly}
                                                        onChange={(value) => this.props.CmsExperienceStore.setshowBannerOnly(value)}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Show Date */}
                                            <>
                                                <Form.Item label='Show Date'>
                                                    <Switch
                                                        checkedChildren='Yes'
                                                        unCheckedChildren='No'
                                                        checked={experience.showDate}
                                                        onChange={(value) => this.props.CmsExperienceStore.setshowDate(value)}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Start Date Time */}
                                            <>
                                                <Form.Item label='Start Date Time'>
                                                    <DatePicker
                                                        size='default'
                                                        style={{ width: '65%', marginRight: 12 }}
                                                        format='DD MMM YYYY'
                                                        value={experience.startDateObject}
                                                        onChange={(e) => this.props.CmsExperienceStore.setstartDateObject(e)}
                                                    />
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardTimePicker
                                                            margin='dense'
                                                            ampm={false}
                                                            id='startdatetime-picker'
                                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                            value={experience.startTimeObject}
                                                            onChange={(e) => this.props.CmsExperienceStore.setstartTimeObject(e)}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change time',
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Form.Item>
                                            </>

                                            {/* End Date Time */}
                                            <>
                                                <Form.Item label='End Date Time'>
                                                    <DatePicker
                                                        size='default'
                                                        style={{ width: '65%', marginRight: 12 }}
                                                        format='DD MMM YYYY'
                                                        value={experience.endDateObject}
                                                        onChange={(e) => this.props.CmsExperienceStore.setendDateObject(e)}
                                                    />
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardTimePicker
                                                            margin='dense'
                                                            ampm={false}
                                                            id='enddatetime-picker'
                                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                            value={experience.endTimeObject}
                                                            onChange={(e) => this.props.CmsExperienceStore.setendTimeObject(e)}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change time',
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Form.Item>
                                            </>

                                            {/* Sort */}
                                            <>
                                                <Form.Item label='Sort'>
                                                    <InputNumber
                                                        className='stm-width-100'
                                                        value={experience.sort}
                                                        onChange={(value) => this.props.CmsExperienceStore.setsort(value)}
                                                        min={1}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    images.map(image => {
                                                        return (
                                                            <Form.Item key={image.id} label={
                                                                image.url === ''
                                                                    ?
                                                                    'Create Banner (Minimum resolution: 640x480)'
                                                                    :
                                                                    <>
                                                                        <Row className='updateexperience-row-label'>
                                                                            <Col span={12} className='updateexperience-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                            <Col span={12} className='updateexperience-col-label-button'>
                                                                                <Button type='danger' onClick={() => this.props.CmsExperienceStore.removeImageById(image.id)}>Delete</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }>
                                                                <Upload
                                                                    listType='picture-card'
                                                                    className='avatar-uploader'
                                                                    showUploadList={false}
                                                                    customRequest={this.dummyRequest}
                                                                    beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                                    onChange={(info) => this.uploadChange(info, image.id, 'Experience')}
                                                                >
                                                                    {
                                                                        image.url !== ''
                                                                            ?
                                                                            <img src={image.url} alt='avatar' className='updateexperience-img' />
                                                                            :
                                                                            <div>
                                                                                <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                <div className='ant-upload-text'>Upload</div>
                                                                            </div>}
                                                                </Upload>
                                                            </Form.Item>
                                                        )
                                                    })
                                                }
                                            </>

                                            {/* Preview */}
                                            <>
                                                <Form.Item label='Preview Banner'>
                                                    <Row>
                                                        <Col span={24} className='updateexperience-col-preview-container'>
                                                            {
                                                                images.length === 1
                                                                    ?
                                                                    null
                                                                    :
                                                                    <Row>
                                                                        <Col className='updateexperience-col-preview-img'>
                                                                            <>
                                                                                <Row>
                                                                                    <Col
                                                                                        span={24}
                                                                                        className={images.length === 2 ? 'updateexperience-col-carousel-container-single' : 'updateexperience-col-carousel-container'}
                                                                                    >
                                                                                        <Carousel>
                                                                                            {
                                                                                                images.filter(fi => fi.url !== '').map(image => {
                                                                                                    return (
                                                                                                        <div key={image.id} className='updateexperience-div-carousel'>
                                                                                                            <Row className='updateexperience-row-carousel'>
                                                                                                                <Col span={24} className='updateexperience-col-carousel'>
                                                                                                                    <img className='updateexperience-img-carousel' src={image.url} alt={image.id} />
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        </div>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </Carousel>
                                                                                    </Col>
                                                                                </Row>
                                                                            </>
                                                                            <>
                                                                                {
                                                                                    experience.showBannerOnly
                                                                                        ?
                                                                                        null
                                                                                        :
                                                                                        <>
                                                                                            {
                                                                                                experience.experienceLanguages.find(fi => fi.languageId === 1)
                                                                                                    ?
                                                                                                    <>
                                                                                                        <Row className='updateexperience-row-detail'>
                                                                                                            <Col span={24} className='updateexperience-col-preview-title'>
                                                                                                                <Text className='updateexperience-text-preview-title'>{experience.experienceLanguages.find(fi => fi.languageId === 1).title}</Text>
                                                                                                            </Col>
                                                                                                            <>
                                                                                                                {
                                                                                                                    experience.showDate
                                                                                                                        ?
                                                                                                                        <>
                                                                                                                            <Col span={24} className='updateexperience-col-preview-date'>
                                                                                                                                <Row>
                                                                                                                                    <Col span={11} className='txt-algn-right'>
                                                                                                                                        <Tag color={'blue'} className='fnt-8 mg-0' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                                                                            <Text>{moment(experience.startDate).format("DD MMMM YYYY")}</Text>
                                                                                                                                        </Tag>
                                                                                                                                    </Col>
                                                                                                                                    <Col span={2} className='txt-algn-center'>
                                                                                                                                        <Text>-</Text>
                                                                                                                                    </Col>
                                                                                                                                    <Col span={11}>
                                                                                                                                        <Tag color={'blue'} className='fnt-8' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                                                                            <Text>{moment(experience.endDate).format("DD MMMM YYYY")}</Text>
                                                                                                                                        </Tag>
                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                        </>
                                                                                                                        :
                                                                                                                        null
                                                                                                                }
                                                                                                            </>
                                                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                                                <Markup content={experience.experienceLanguages.find(fi => fi.languageId === 1).description} />
                                                                                                            </Paragraph>
                                                                                                        </Row>
                                                                                                    </>
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                }
                                                                            </>

                                                                        </Col>
                                                                    </Row>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </>

                                            {/* Button */}
                                            <>
                                                <Form.Item>
                                                    {
                                                        experience.id === 0
                                                            ?
                                                            <Button onClick={this.create} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                            :
                                                            <Button onClick={this.update} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>
                                                    }

                                                    <Button onClick={this.cancel}>Cancel</Button>
                                                </Form.Item>
                                            </>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default ExperienceUpdate;